import { shallowEqual } from 'react-redux'
import { useIntercom } from 'react-use-intercom'

import { useAppSelector } from 'store/hooks'
import { State } from 'store/state'

export const useUpdateIntercomAuditCompletion = (
  completionPercentage?: number
) => {
  const { update: updateIntercom } = useIntercom()

  const { intercom, charlieCompanyId, auditStatus } = useAppSelector(
    (state: State) => ({
      intercom: state.authReducer.intercom,
      charlieCompanyId: state.authReducer.charlieUser?.companyId,
      auditStatus: state.auditReducer.status,
    }),
    shallowEqual
  )

  const inStateCompletion = auditStatus?.company
    ? auditStatus.company?.percent
    : undefined

  const percentage = inStateCompletion || completionPercentage

  if (
    charlieCompanyId &&
    percentage &&
    intercom?.intercomUserHash &&
    intercom?.intercomId
  ) {
    updateIntercom({
      userHash: intercom.intercomUserHash,
      userId: intercom.intercomId,
      company: {
        companyId: charlieCompanyId,
        customAttributes: {
          assessment_completion: Math.round(percentage),
        },
      },
    })
  }
}
